import {
  GroupAdminRightsInterface,
  GroupMemberPermissionInterface,
  ChannelAdminRightsInterface,
} from '.'
import { t } from '$i18n'

export const GROUP_ADMIN_RIGHTS: GroupAdminRightsInterface[] = [
  {
    id: 'addNewAdmins',
    localId: t('hallPermissionsPage.groupAdminRights.addNewAdmins'),
  },
  {
    id: 'banUsers',
    localId: t('hallPermissionsPage.groupAdminRights.banUsers'),
  },
  {
    id: 'changeHallInfo',
    localId: t('hallPermissionsPage.groupAdminRights.changeHallInfo'),
  },
  {
    id: 'deleteMessages',
    localId: t('hallPermissionsPage.groupAdminRights.deleteMessages'),
  },
  {
    id: 'inviteViaLink',
    localId: t('hallPermissionsPage.groupAdminRights.inviteViaLink'),
  },
  {
    id: 'pinMessage',
    localId: t('hallPermissionsPage.common.pinMessages'),
  },
]

export const GROUP_MEMBER_PERMISSIONS: GroupMemberPermissionInterface[] = [
  {
    id: 'addMembers',
    localId: t('hallPermissionsPage.groupMemberPermissions.addMembers'),
  },
  {
    id: 'changeHallInfo',
    localId: t('hallPermissionsPage.groupMemberPermissions.changeHallInfo'),
  },
  {
    id: 'sendMessage',
    localId: t('hallPermissionsPage.groupMemberPermissions.sendMessage'),
  },
  {
    id: 'sendMedia',
    localId: t('hallPermissionsPage.groupMemberPermissions.sendMedia'),
    requires: 'sendMessage',
  },
  {
    id: 'sendWapp',
    localId: t('hallPermissionsPage.common.sendWapp'),
    requires: 'sendMessage',
  },
  {
    id: 'pinMessage',
    localId: t('hallPermissionsPage.common.pinMessages'),
  },
]

export const CHANNEL_ADMIN_RIGHTS: ChannelAdminRightsInterface[] = [
  {
    id: 'questionSupport',
    localId: t('hallPermissionsPage.channelAdminRights.questionSupport'),
    exclusive: true,
  },
  {
    id: 'changeHallInfo',
    localId: t('hallPermissionsPage.channelAdminRights.changeHallInfo'),
  },
  {
    id: 'editMessage',
    localId: t('hallPermissionsPage.channelAdminRights.editMessage'),
  },
  {
    id: 'deleteMessages',
    localId: t('hallPermissionsPage.channelAdminRights.deleteMessages'),
  },
  {
    id: 'addMembers',
    localId: t('hallPermissionsPage.groupMemberPermissions.addMembers'),
  },
  {
    id: 'addNewAdmins',
    localId: t('hallPermissionsPage.groupAdminRights.addNewAdmins'),
  },
  {
    id: 'sendMessage',
    localId: t(
      'hallPermissionsPage.groupMemberPermissionsOverride.sendMessage',
    ),
  },
  {
    id: 'sendMedia',
    localId: t('hallPermissionsPage.groupMemberPermissions.sendMedia'),
    requires: 'sendMessage',
  },
  {
    id: 'pinMessage',
    localId: t('hallPermissionsPage.common.pinMessages'),
  },
]
